// extracted by mini-css-extract-plugin
export default {"button":"Button-module--button--8fc92","inert":"Button-module--inert--d9d87","morph":"Button-module--morph--68e58","hidden":"Button-module--hidden--2cc34"};